<template>
  <base-alert
    :modalId="'cancel-deadhead-trip-model-' + tripID"
    icon="popup-warning-icon"
    modalClass="cancel-deadhead-trip-modal"
    :title="$t('cancel-trip')"
    :description="$t('confirm-cancel') + ` #${tripID} ${isLangRtl ? '؟' : '?'}`"
    type="wide"
  >
    <template #content>
      <section class="cancel-reason">
        <p class="cancel-reason__header">{{ $t('reason-for-the-cancellation') }}</p>
        <base-textarea
          :value="reason"
          @change-value="getReason"
          :rows="4"
          placeholder="write-the-reason-for-cancellation-here"
          id="cancel-reason-input"
          :is_required="true"
          :rules="'required'"
          name="cancellation-reason"
          :remove_default_margin="true"
        >
        </base-textarea>
      </section>
    </template>
    <template #buttons>
      <base-button variant="secondary" @click="hideModal" class="col-3 mb-3">
        {{ $t('no') }}
      </base-button>
      <base-button
        variant="primary"
        @click="cancelTrip"
        class="col-3 mb-3"
        :disabled="!reason || !reason.trim()"
      >
        {{ $t('yes') }}
      </base-button>
    </template>
  </base-alert>
</template>

<script>
export default {
  props: ['tripID'],
  emits: ['cancelTrip'],
  data() {
    return {
      reason: '',
    }
  },
  methods: {
    getReason(reason) {
      this.reason = reason
    },
    hideModal() {
      this.reason = ''
      this.$bvModal.hide('cancel-deadhead-trip-model-' + this.tripID)
    },
    cancelTrip() {
      if (!this.reason || !this.reason.trim()) {
        return
      }
      this.$emit('cancelTrip', this.reason)
      this.hideModal()
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/operations.json'),
      ar: require('@/services/i18n/locales/ar/operations.json'),
    },
  },
}
</script>

<style lang="scss">
.cancel-deadhead-trip-modal {
  img {
    width: 40px !important;
  }

  .cancel-reason {
    &__header {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.006em;
      color: var(--color-17);
      margin-bottom: 4px;
    }
  }
}
</style>
